import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DynamicFormService } from '@ntap/common';
import {
  ActionComponentNew,
  ActionResult,
  BackendDataSourceService,
  ItemView,
  ItemViewProviderDirective,
  NotificationService
} from '@ntap/core';
import {
  withLatestFrom,
  first,
  map,
  mergeMap,
  Observable,
  ReplaySubject,
  Subject,
  shareReplay,
  switchMap,
  tap
} from 'rxjs';

import { ChooseFromNormativeDbService } from '@app/services';

@Component({
  selector: 'app-choose-person-normative-database',
  templateUrl: '../../shared/components/actions/common-action-template.html'
})
export class ChooseFromPersonNormativeDatabaseComponent
  extends ActionComponentNew<ActionResult>
  implements OnInit
{
  chosenPersonChanged$: Observable<number>;
  itemState$: Observable<any>;
  executeEvent$$: Subject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    protected override notificationService: NotificationService,
    protected http: HttpClient,
    protected itemViewProvider: ItemViewProviderDirective<ItemView>,
    protected formService: DynamicFormService,
    protected backendDatasource: BackendDataSourceService,
    protected chooseFromNormativeDbService: ChooseFromNormativeDbService
  ) {
    super(notificationService);
  }

  ngOnInit() {
    this.itemState$ = this.itemViewProvider.item$;
    this.chosenPersonChanged$ = this.formService
      .getFormControl('en~arhiv_posjednik~agent_normativna_baza_id')
      .valueChanges.pipe(shareReplay(1));
    this.isDisabled$ = this.chosenPersonChanged$.pipe(
      map((changed) => !changed)
    );
  }

  protected doExecute(): Observable<ActionResult> {
    const execute$ = this.executeEvent$$.asObservable().pipe(
      first(),
      switchMap(() => this.chosenPersonChanged$),
      withLatestFrom(this.itemState$),
      mergeMap(([chosenPersonId, itemState]) => {
        const requestState = Object.assign({}, itemState, {
          'en~arhiv_posjednik~agent_normativna_baza_id': chosenPersonId
        });
        return this.backendDatasource
          .getViewData('normativna_baza_agent', requestState)
          .pipe(
            map((item) => {
              const itemWithAgentData = Object.assign({}, itemState, item);
              this.itemViewProvider.updateItem(itemWithAgentData);
              return itemWithAgentData as ActionResult;
            }),
            tap(() => {
              this.chooseFromNormativeDbService.chooseAgent();
            })
          );
      })
    );
    this.executeEvent$$.next(true);
    return execute$;
  }
}
